import React, { FC, PropsWithChildren } from 'react';

import clsx from 'clsx';
import './Label.css';

export type FormControlLabelProps = PropsWithChildren<
	React.HTMLAttributes<HTMLLabelElement> & {
		formControlId: string;
		title?: string;
		acceptanceTestTargetId?: string;
		required?: boolean;
	}
>;

export const FormControlLabel: FC<FormControlLabelProps> = ({
	title,
	children,
	formControlId,
	acceptanceTestTargetId,
	required,
	className,
}) => (
	<label
		className={clsx('form-control-label', className)}
		data-pp-at-target={acceptanceTestTargetId}
		htmlFor={formControlId}
	>
		{title && (
			<span className="form-control-text">
				{title}
				{required && <span className="form-control-required">*</span>}
			</span>
		)}
		{children}
	</label>
);
